import {
  ISingleUnwrappedWindow,
  SingleUnwrappedWindow,
  WindowState,
} from '@project/store/Window';
import { Table } from '@datum-group/isogd-openapi/lib';
import { FilterValue } from '@project/components/Module/Table/Filters/FilterInput/types';
import { computed, makeObservable, observable } from 'mobx';
import { TableCollection } from '@project/store/TableCollection';

interface WindowContentTableData {
  table: Table;
  filterParam?: FilterValue;
}

export class TableWindowController
  implements ISingleUnwrappedWindow<WindowContentTableData>
{
  private _windowCollection: SingleUnwrappedWindow<WindowContentTableData>;

  @observable private _tableCollection: TableCollection;

  constructor() {
    this._tableCollection = new TableCollection();
    this._windowCollection =
      new SingleUnwrappedWindow<WindowContentTableData>();

    makeObservable(this);
  }

  @computed get active() {
    return this._windowCollection.active;
  }

  @computed get windows(): Record<string, WindowState<WindowContentTableData>> {
    return this._windowCollection.windows;
  }

  @computed get tables(): TableCollection {
    return this._tableCollection;
  }

  wrap = (layerName?: string) => {
    this._windowCollection.wrap(layerName);
  };

  unwrap = (layerName?: string) => {
    this._windowCollection.unwrap(layerName);
  };

  close = (layerName?: string) => {
    const id = layerName || this.active;

    if (!id) return;

    const tableId = this._windowCollection.windows[id]?.data.table.table_name;

    if (tableId) {
      this._tableCollection.delete(tableId);
    }

    this._windowCollection.close(id);
  };

  async open(name: string, data: WindowContentTableData): Promise<void> {
    await this._tableCollection.set(name, data.filterParam);

    const tableController = this._tableCollection.list.get(name);

    if (!tableController) {
      const msg = `Не удалось получить таблицу - ${
        data.table.description ?? name
      }`;

      throw new Error(msg);
    }

    this._windowCollection.open(name, data);
  }
}
